import { FC, useState } from 'react';
import { DeleteOptionRecipesStep } from "./DeleteOptionRecipes.types";
import SelectOptionRecipes from "./SelectOptionRecipes/SelectOptionRecipes";
import { useDeleteOptionRecipes } from "../../../services/option/option.service";
import { Subrecipe } from "../../../services/subrecipe/subrecipe.types";
import Header from "../../../common/Header/Header";
import UnsavedChangesModal from "../../../common/UnsavedChangesModal/UnsavedChangesModal";
import ReviewChanges from "./ReviewChanges/ReviewChanges";
import Confirmation from "./Confirmation/Confirmation";

const DeleteOptionRecipes: FC = () => {
    const [selectedOptionRecipes, setSelectedOptionRecipes] = useState<Subrecipe[]>([])
    const [step, setStep] = useState<DeleteOptionRecipesStep>(DeleteOptionRecipesStep.SelectOptionRecipes);
    const { mutate, data: deletedOptionRecipes, isLoading } = useDeleteOptionRecipes();

    const renderStep = () => {
        switch (step) {
            case DeleteOptionRecipesStep.SelectOptionRecipes:
                return <SelectOptionRecipes
                    selectedOptionRecipes={selectedOptionRecipes}
                    setSelectedOptionRecipes={setSelectedOptionRecipes}
                    setStep={setStep}
                />;
            case DeleteOptionRecipesStep.ReviewChanges:
                return <ReviewChanges
                    selectedOptionRecipes={selectedOptionRecipes}
                    setStep={setStep}
                    mutate={mutate}
                    isLoading={isLoading}
                />;
            case DeleteOptionRecipesStep.Confirmation:
                return <Confirmation
                    deletedOptionRecipes={deletedOptionRecipes?.data}
                />;
        }
    };

    return (
        <>
            <Header
                breadcrumb={{ label: 'Back to Option Recipes', to: '/optionrecipes'}}
                titleTestId='DeleteOptionRecipeTitle'
                title='Delete Option Recipes'
                stepTracker={{
                    currentStep: step,
                    steps: [{ label: 'Select' }, { label: 'Review' }, { label: 'Confirm' }],
                }}
            />
            {renderStep()}
            <UnsavedChangesModal unsavedChangesExist={step === DeleteOptionRecipesStep.ReviewChanges} />
        </>
    );
};

export default DeleteOptionRecipes;